export default __webpack_public_path__ + "static/media/IMG_6324.8408eaca.JPG";